import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './registerServiceWorker';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss';
// import Router from 'vue-router'
// import TreeChart from 'vue-tree-chart';
import axios from 'axios';
import '@/permission';
import config from './config';
import {
  checkStatus,
  checkType,
  formatTime,
  toString,
  secondFormat,
  accountStatus,
  upperLevel,
  accountValidity,
  checkStatusClass,
  uploadFileStatus
} from './common/filters';

Vue.use(Element);


// const routerPush = Router.prototype.push
// Router.prototype.push = (location: any) {
//   return routerPush.call(this, location)
// }
// const routerPush = Router.prototype.push;
// Router.prototype.push = function push(location: any) {
//   return (routerPush.call(this, location) as any).catch((error: any) => error);
// };

// Vue.use(TreeChart);
Vue.config.productionTip = false;
axios.defaults.baseURL = config.BASE_API;

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
Vue.prototype.$http = axios;
// 过滤器定义
Vue.filter('checkStatus', checkStatus);
Vue.filter('checkType', checkType);
Vue.filter('formatTime', formatTime);
Vue.filter('toString', toString);
Vue.filter('secondFormat', secondFormat);
Vue.filter('accountStatus', accountStatus);
Vue.filter('upperLevel', upperLevel);
Vue.filter('accountValidity', accountValidity);
Vue.filter('checkStatusClass', checkStatusClass);
Vue.filter('uploadFileStatus', uploadFileStatus);

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
